<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.49 18.49" class="icon">
        <title>plus</title>
        <line x1="9.25" y1="0.75" x2="9.25" y2="17.74"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px" v-bind:style="{stroke: color}"/>
        <line x1="17.74" y1="9.26" x2="0.75" y2="9.26"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px" v-bind:style="{stroke: color}"/>
    </svg>
</template>

<script>
    export default {
        name: "IconPlus",

        props: {
            color: {
                type: String,
                default: '#231f20'
            }
        }
    }
</script>
